import _ from 'lodash'
import * as React from 'react'
import { Select, Box, MenuItem } from '@mui/material'

const Selector = ({ sxBox, placeholder, opts, ...rest }) => {
  return (
    <Box sx={sxBox}>
      <Select size="small" sx={{ width: '100%' }} displayEmpty {...rest}>
        <MenuItem disabled value="" sx={{ filter: 'brightness(0)' }}>
          <em style={{ color: '#a2a2a2', fontStyle: 'normal' }}>{placeholder}</em>
        </MenuItem>
        {_.map(opts, obj => (
          <MenuItem key={`item-${obj.title}-${obj.id}`} value={obj.id}>
            {obj.title}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

export default Selector
